<template>
  <span v-if="icon" class="app-icon" v-on="$listeners">
    <!-- eslint-disable vue/no-v-html -->
    <span class="app-icon__icon" v-html="icon" />
    <!-- eslint-enable -->
  </span>
</template>

<script>
export const ICON_NAME = {
  SUN: 'sun',
  MOON: 'moon',
  SUN_AND_MOON: 'sun-and-moon'
};

export default {
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: null
    };
  },
  async created() {
    this.icon = (await import(`@/assets/icons/${this.name}.icon`)).default;
  }
};
</script>

<style lang="scss">
.app-icon * {
  fill: var(--app-icon-color, #000000);
  width: var(--app-icon-size, 28px);
  cursor: inherit;
}

.app-icon {
  display: inline-block;

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
  }
}
</style>
